import React, { Component } from 'react';

import { collapsibleModalPropTypes } from 'components/CollapsibleModals';
import { getDocumentPreviewType } from 'helpers/documentsHelpers';
import DocumentPreview from 'components/cards/document/DocumentPreview';

export default class DocumentModal extends Component {
    static propTypes = collapsibleModalPropTypes;

    render() {
        const { params: document, close } = this.props;

        const previewType = getDocumentPreviewType(document);
        const docProps = {
            document,
            documentPreviewType: previewType
        };

        return <DocumentPreview {...docProps} close={close} isModal />;
    }
}
